import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

/** Loading placeholder matching ui-waiting-on-you-card-container's layout. */
@Component({
  selector: 'wcg-waiting-on-you-card-skeleton',
  imports: [MatCardModule, NgxSkeletonLoaderComponent],
  templateUrl: './waiting-on-you-card-skeleton.component.html',
})
export class WaitingOnYouCardSkeletonComponent {}
